const leftMenu = [
  {
    label: 'leftMenu.feedback',
    path: '/feedback',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', 'MECHANIC']
  }
];
export default leftMenu;
